"use client";

import { useUserRealmId } from "@easybiz/component-shared";
import { collection, getFirestore, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";

export default (orderId) => {
  const realmId = useUserRealmId();
  const [receipts, setReceipts] = useState(null);

  useEffect(() => {
    setReceipts(null);
    if (realmId && orderId) {
      return onSnapshot(
        query(
          collection(getFirestore(), `realms/${realmId}/orders/${orderId}/collection_receipts`),
          orderBy("createDate", "desc")
        ),
        (result) => setReceipts(result.docs)
      );
    }
  }, [realmId, orderId]);

  return receipts;
};
